import request from 'local_modules/request'
import { reducers, getState } from 'redux/core'
import { constants } from 'helpers'


const setFetching = (isFetching) => reducers.marketplace.cashierSalesFoodPage.setFetching(isFetching)

const fetch = () => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  const {
    me: { id },
    marketplace: { accessLevel: { edu, rpc } },
  } = getState()
  const { cashierAccessLevel } = !isRpc ? edu : rpc

  const schoolId = cashierAccessLevel.find(({ cashier }) => id === cashier.id).school.id

  return request.get(prefix.cashierOfflineSales + `/${schoolId}`)
    .then(({ data }) => data)
    .then((sales) => {
      reducers.marketplace.cashierSalesFoodPage.setSales(sales)
    })
    .catch((error) => {
      console.log(error)
    })
}

// const fetchCategories = () => {
//   const { marketplace: { layersNavigation: { toolType } } } = getState()
//
//   return request.get(prefix.categories + `/${toolType}?all=false`)
//     .then(({ data }) => data)
//     .then((categories) => reducers.marketplace.cashierSalesFoodPage.setCategories(categories))
//     .catch((error) => console.log(error))
// }

const setSales = (_nomenclatures) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  const {
    me: { id },
    marketplace: { accessLevel: { edu, rpc } },
  } = getState()
  const { cashierAccessLevel } = !isRpc ? edu : rpc

  const schoolId = cashierAccessLevel.find(({ cashier }) => id === cashier.id).school.id
  const nomenclatures = _nomenclatures.map(({ id, nomenclature, count }) => ({
    id,
    nomenclature,
    count,
  }))

  return request.post(prefix.cashierOfflineSales + `/${schoolId}`, nomenclatures)
    .then(({ data }) => data)
    .catch((error) => {
      console.log(error)
    })
}


export default {
  setFetching,
  fetch,
  setSales,
}
